// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    MIC_2020_SECTORS_LOADING() {
      return {
        isLoading: true
      };
    },
    MIC_2020_SECTORS_LOADED() {
      return {
        isLoading: false,
        sectors: action.micSectors
      };
    },
    MIC_2020_SECTORS_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.micSector.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
